import type { ProgressTrackingSummary } from '@/types/cycle-evaluation/ProgressTrackingSummary';

import { api } from '@/api/api';

export default {
    async getProgressTrackingSummary(): Promise<ProgressTrackingSummary> {
        const response = await api.get<ProgressTrackingSummary>(
            '/cycleevaluation/progress-tracking-summary',
        );

        return response.data;
    },
};
